/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Badge_Copy_MarkdownInputs */

const en_directory_submit_badge_copy_markdown = /** @type {(inputs: Directory_Submit_Badge_Copy_MarkdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy Markdown`)
};

const zh_directory_submit_badge_copy_markdown = /** @type {(inputs: Directory_Submit_Badge_Copy_MarkdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复制 Markdown`)
};

/**
* | output |
* | --- |
* | "Copy Markdown" |
*
* @param {Directory_Submit_Badge_Copy_MarkdownInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_badge_copy_markdown = /** @type {((inputs?: Directory_Submit_Badge_Copy_MarkdownInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Badge_Copy_MarkdownInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_badge_copy_markdown(inputs)
	return zh_directory_submit_badge_copy_markdown(inputs)
});
export { directory_submit_badge_copy_markdown as "directory.submit.badge_copy_markdown" }